module.exports = __webpack_public_path__ + "static/img/p8.4b11561.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/p8.jpg
// module id = ngBI
// module chunks = 0